
import { defineComponent, onMounted, Ref, ref } from 'vue';
import { throttle } from 'lodash';
import Indicator from '@/shared/content/blocks/native-scroll/Indicator.vue';

export default defineComponent({
    name: 'IndicatorsForNativeHorizontalScroll',
    components: { Indicator },
    props: {
        quantityOffScrollElements: {
            type: Number,
            required: true,
        },
    },
    setup(props) {
        const root: Ref<HTMLElement | null> = ref(null);
        const scrollItemsArray: Ref<any[]> = ref([]);
        const activeIndex: Ref<Number> = ref(0);
        let scrollContainerElement: Element | null | undefined;

        const scrollToClickedItem = (event: any, index: number): void => {
            if (scrollContainerElement) {
                (scrollContainerElement as Element).scrollLeft = scrollItemsArray.value[index];
            }
        };

        const defineAllScrollItems = (): void => {
            if (scrollContainerElement) {
                for (let index = 0; index < props.quantityOffScrollElements; index++) {
                    const scrollElement: Element = (scrollContainerElement as Element).children[index];
                    scrollItemsArray.value.push((scrollElement as HTMLElement).offsetLeft);
                }
            }
        };

        const onScroll = (event: any): void => {
            const scrollPosition = event.target.scrollLeft;
            const closestScrollElement = scrollItemsArray.value.reduce((initialValue: any, currentValue: any) => {
                return Math.abs(currentValue - scrollPosition) < Math.abs(initialValue - scrollPosition) ? currentValue : initialValue;
            });

            activeIndex.value = scrollItemsArray.value.indexOf(closestScrollElement);
        };

        const setScrollEventListener = (): void => {
            if (scrollContainerElement) {
                const debouncedHandleScrollEvent = throttle(onScroll, 250);
                (scrollContainerElement as Element).addEventListener('scroll', (event: any) => debouncedHandleScrollEvent(event));
            }
        };

        onMounted(() => {
            scrollContainerElement = root.value?.previousElementSibling;
            defineAllScrollItems();
            setScrollEventListener();
        });

        return {
            root,
            activeIndex,
            scrollToClickedItem,
            scrollItemsArray,
        };
    },
});

